import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost, AxiosPatch, AxiosDelete, AxiosFilePatch } from '../../../utils/axios';
import * as actions from './mushroomActions';

function* fetchMushroomContexts(action) {
  try {
    const filters = action.payload || {};
    const queryParams = new URLSearchParams();

    if (filters.org_id) queryParams.append('org_id', filters.org_id);
    if (filters.category) queryParams.append('category', filters.category);
    if (filters.difficulty) queryParams.append('difficulty', filters.difficulty);
    if (filters.search) queryParams.append('search', filters.search);

    const queryString = queryParams.toString();
    const url = `/mycore/mushroom-context/list/${queryString ? `?${queryString}` : ''}`;

    const result = yield call(AxiosCall, url);
    yield put(actions.fetchMushroomContextsSuccess(result.data));
  } catch (error) {
    yield put(actions.fetchMushroomContextsFailure(error));
  }
}

function* fetchMushroomDetail(action) {
  try {
    const { id, orgId } = action.payload;
    const queryParams = new URLSearchParams();
    if (orgId) queryParams.append('org_id', orgId);
    const queryString = queryParams.toString();
    const url = `/mycore/mushroom-context/${id}/detail/${queryString ? `?${queryString}` : ''}`;
    const result = yield call(AxiosCall, url);
    yield put(actions.fetchMushroomDetailSuccess(result.data));
  } catch (error) {
    yield put(actions.fetchMushroomDetailFailure(error));
  }
}

function* createMushroomVariety(action) {
  try {
    const result = yield call(AxiosPost, '/mycore/mushroom-context/create-variety/', action.payload);
    yield put(actions.createMushroomVarietySuccess(result.data));
  } catch (error) {
    yield put(actions.createMushroomVarietyFailure(error));
  }
}

function* createMushroomHybrid(action) {
  try {
    const result = yield call(AxiosPost, '/mycore/mushroom-context/create-hybrid/', action.payload);
    yield put(actions.createMushroomHybridSuccess(result.data));
  } catch (error) {
    yield put(actions.createMushroomHybridFailure(error));
  }
}

function* updateMushroomContext(action) {
  try {
    const { id, data } = action.payload;
    const result = yield call(AxiosPatch, `/mycore/mushroom-context/${id}/update-variety/`, data);
    yield put(actions.updateMushroomContextSuccess(result.data));
  } catch (error) {
    yield put(actions.updateMushroomContextFailure(error));
  }
}

function* deleteMushroomContext(action) {
  try {
    const { id } = action.payload;
    yield call(AxiosDelete, `/mycore/mushroom-context/${id}/delete-variety/`);
    yield put(actions.deleteMushroomContextSuccess(id));
  } catch (error) {
    yield put(actions.deleteMushroomContextFailure(error));
  }
}

function* fetchSpeciesSpawnLineage(action) {
  try {
    const { speciesId, orgId } = action.payload;
    const queryParams = new URLSearchParams();
    if (orgId) queryParams.append('org_id', orgId);
    const queryString = queryParams.toString();
    const url = `/mycore/mushroom-context/${speciesId}/spawn-lineage/${queryString ? `?${queryString}` : ''}`;
    const result = yield call(AxiosCall, url);
    yield put(actions.fetchSpeciesSpawnLineageSuccess(result.data));
  } catch (error) {
    yield put(actions.fetchSpeciesSpawnLineageFailure(error));
  }
}

function* uploadMushroomImage(action) {
  try {
    const { id, file } = action.payload;
    const formData = new FormData();
    formData.append('image', file);
    const result = yield call(AxiosFilePatch, `/mycore/mushroom-context/${id}/upload-image/`, formData);
    yield put(actions.uploadMushroomImageSuccess(result.data));
  } catch (error) {
    yield put(actions.uploadMushroomImageFailure(error));
  }
}

export default function* mushroomSaga() {
  yield all([
    takeLatest(actions.FETCH_MUSHROOM_CONTEXTS.REQUEST, fetchMushroomContexts),
    takeLatest(actions.FETCH_MUSHROOM_DETAIL.REQUEST, fetchMushroomDetail),
    takeLatest(actions.CREATE_MUSHROOM_VARIETY.REQUEST, createMushroomVariety),
    takeLatest(actions.CREATE_MUSHROOM_HYBRID.REQUEST, createMushroomHybrid),
    takeLatest(actions.UPDATE_MUSHROOM_CONTEXT.REQUEST, updateMushroomContext),
    takeLatest(actions.DELETE_MUSHROOM_CONTEXT.REQUEST, deleteMushroomContext),
    takeLatest(actions.UPLOAD_MUSHROOM_IMAGE.REQUEST, uploadMushroomImage),
    takeLatest(actions.FETCH_SPECIES_SPAWN_LINEAGE.REQUEST, fetchSpeciesSpawnLineage),
  ]);
}
